import { render, staticRenderFns } from "./overlay_type.vue?vue&type=template&id=23cbc5a3&scoped=true"
import script from "./overlay_type.vue?vue&type=script&lang=js"
export * from "./overlay_type.vue?vue&type=script&lang=js"
import style0 from "./overlay_type.vue?vue&type=style&index=0&id=23cbc5a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cbc5a3",
  null
  
)

export default component.exports